module.exports = __webpack_public_path__ + "img/red-icon(3).4430dac4.png";